module.exports = __webpack_public_path__ + "static/media/HPTrivia.c7abb329.png";